import app from './app/app.slice';
import tracking from './tracking/tracking.slice';
import { combineSlices } from '@reduxjs/toolkit';

declare global {
  interface LazyLoadedSlices {
    app: typeof app;
    tracking: typeof tracking;
  }
}

export default combineSlices({
  app,
  tracking,
}).withLazyLoadedSlices<LazyLoadedSlices>();
